import { render, staticRenderFns } from "./TablaPresupuestosPorGrupoPorMeses.vue?vue&type=template&id=bfba7e6c"
import script from "./TablaPresupuestosPorGrupoPorMeses.vue?vue&type=script&lang=js"
export * from "./TablaPresupuestosPorGrupoPorMeses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports